var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H37.9973C43.5202 0 47.9973 4.47715 47.9973 10V37.9973C47.9973 43.5202 43.5202 47.9973 37.9973 47.9973H10C4.47715 47.9973 0 43.5202 0 37.9973V10Z",
    fill: "#D0438D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9883 32.9949V30.9958C27.9883 29.9353 27.5671 28.9183 26.8172 28.1685C26.0674 27.4187 25.0504 26.9974 23.99 26.9974H17.9925C16.9321 26.9974 15.9151 27.4187 15.1652 28.1685C14.4154 28.9183 13.9941 29.9353 13.9941 30.9958V32.9949",
    stroke: "white",
    strokeWidth: 1.99917,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9913 22.9991C23.1995 22.9991 24.9896 21.209 24.9896 19.0007C24.9896 16.7925 23.1995 15.0024 20.9913 15.0024C18.783 15.0024 16.9929 16.7925 16.9929 19.0007C16.9929 21.209 18.783 22.9991 20.9913 22.9991Z",
    stroke: "white",
    strokeWidth: 1.99917,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9858 32.9949V30.9958C33.9852 30.1099 33.6903 29.2493 33.1475 28.5491C32.6048 27.8489 31.8448 27.3488 30.9871 27.1274",
    stroke: "white",
    strokeWidth: 1.99917,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9883 15.1324C28.8483 15.3526 29.6106 15.8528 30.155 16.5541C30.6994 17.2554 30.9949 18.1179 30.9949 19.0057C30.9949 19.8935 30.6994 20.7561 30.155 21.4574C29.6106 22.1587 28.8483 22.6589 27.9883 22.8791",
    stroke: "white",
    strokeWidth: 1.99917,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/Users.87aa70386c7f49515f981faf151b1d5a.svg";
export { ForwardRef as ReactComponent };